
/* -----------------------------------------------------------------------------------------------------
  - Created: [17-06-2025] by [SREERAJ]
  - Modified: [09-07-2025] by [SREERAJ]
  - Description: This file contains Icons for handle globally
  -------------------------------------------------------------------------------------------------------
*/
import { FaFileInvoice, FaInfoCircle, FaQuestionCircle, FaRegEye, FaTrashAlt } from 'react-icons/fa';
import { BsPencilSquare } from 'react-icons/bs';
import { FcKey } from 'react-icons/fc';
import { RiQuestionAnswerFill } from 'react-icons/ri';
import { MdAddBox, MdOutlineSendToMobile } from "react-icons/md";
import { TbCreditCardPay } from 'react-icons/tb';
import { SlCalender } from "react-icons/sl";
import { HiUserGroup } from "react-icons/hi2";
import { RiGroupLine } from "react-icons/ri";
import { MdDashboard } from "react-icons/md";
import { FaBuilding } from "react-icons/fa";
import { MdLogout } from "react-icons/md";
import { MdOutlineEngineering } from "react-icons/md";
import { GrTechnology } from "react-icons/gr";
import { FaTools } from "react-icons/fa";
import { GoProjectSymlink } from "react-icons/go";
import { FaHelmetSafety } from "react-icons/fa6";
import { RiCalendarScheduleFill } from "react-icons/ri";
import { MdEditDocument } from "react-icons/md";
import { IoCalendarClear } from "react-icons/io5";
import { IoDesktop } from "react-icons/io5";
import { FaPersonDigging } from "react-icons/fa6";
import { IoMdSettings } from "react-icons/io";
import { MdManageAccounts } from "react-icons/md";
import { RiFileList2Fill } from "react-icons/ri";
import { AiFillSchedule } from "react-icons/ai";
import { RxActivityLog } from "react-icons/rx";
import { TbReportSearch } from "react-icons/tb";
import { IoMdClose } from "react-icons/io";
import { FiCheck } from "react-icons/fi";
import { MdOutlineEventAvailable } from "react-icons/md";
import { MdDescription } from "react-icons/md";
import { FaUserLock } from "react-icons/fa6";
import { MdMarkEmailRead } from "react-icons/md";
import { MdRateReview } from "react-icons/md";
import { SiLevelsdotfyi } from "react-icons/si";
import { BsPersonVideo2 } from "react-icons/bs";
import { BsCalendar3WeekFill } from "react-icons/bs";
import { IoCalendarSharp } from "react-icons/io5";
import { FaCalendarAlt } from "react-icons/fa";
import { BsPersonVcardFill } from "react-icons/bs";
import { FaToolbox } from "react-icons/fa6";
import { FaUsers } from "react-icons/fa6";
import { GoProjectRoadmap } from "react-icons/go";
import { FaSitemap } from "react-icons/fa";
import { LuMessageSquareReply } from "react-icons/lu";
import { MdPendingActions } from "react-icons/md";
import { TfiHandStop } from "react-icons/tfi";
import { VscRunErrors } from "react-icons/vsc";
import { VscRunCoverage } from "react-icons/vsc";
import { MdAssignmentAdd } from "react-icons/md";
import { CgNotes } from "react-icons/cg";
import { IoMdDoneAll } from "react-icons/io";
import { IoMdWarning } from "react-icons/io";
import { FaRegCircleStop } from "react-icons/fa6";
import { GoHistory } from "react-icons/go";


import { FaFilePdf } from "react-icons/fa";
import { FaFileExcel } from "react-icons/fa";

export const Icons = {

  // Action button menus
  View: FaRegEye,
  Edit: BsPencilSquare,
  History: GoHistory,
  Password: FcKey,
  Comment: RiQuestionAnswerFill,
  Query: FaQuestionCircle,
  QueryReply: LuMessageSquareReply,
  Info: FaInfoCircle,
  Mobilize: MdOutlineSendToMobile,
  InvoiceView: FaFileInvoice,
  Pay: TbCreditCardPay,
  Calender: SlCalender,
  ReportStatusChange: TbReportSearch,
  Add: MdAddBox,
  Close: IoMdClose,
  Check: FiCheck,
  Remove: FaTrashAlt,
  Cancel: FaRegCircleStop,
  availableLeave: MdOutlineEventAvailable,
  Description: MdDescription,
  Start: VscRunCoverage,
  Complete: IoMdDoneAll,
  Pause: TfiHandStop,
  Resume: VscRunErrors,
  AddReport: MdAssignmentAdd,
  ViewReport: CgNotes,
  PdfIcon: FaFilePdf,
  ExcelIcon: FaFileExcel,

  //ADDITIONAL ICONS
  Warning: IoMdWarning,

  // Sidebar main menus
  Dashboard: MdDashboard,            // Dashboard section
  Worksites: FaBuilding,             // Worksites section
  Resources: HiUserGroup,            // Resources section
  Reports: RiGroupLine,              // Reports section
  Settings: IoMdSettings,           // Settings section
  Leave: MdManageAccounts,          // Leave section
  Schedule: RiCalendarScheduleFill, // Schedule section
  Auditlogs: RxActivityLog,         // Audit logs section
  Logout: MdLogout,                 // Logout action

  // Submenu icons under Worksites
  Projects: GoProjectSymlink,       // Project submenu under worksites
  Sites: FaPersonDigging,           // Sites submenu under worksites
  WorksiteSchedules: RiCalendarScheduleFill, // Schedule submenu under worksites

  // Submenu icons under Resources
  Technology: GrTechnology,         // Technology submenu
  Equipment: FaTools,               // Equipment submenu
  Workforce: MdOutlineEngineering,  // Workforce submenu

  // Submenu icons under Reports
  BinReport: MdPendingActions, //Bin report
  EmployeeReport: BsPersonVcardFill,   // Employee report
  ProjectReport: GoProjectRoadmap,   // Project Report 

  EquipmentReport: FaHelmetSafety,  // Equipment report 
  WorksiteReport: FaSitemap, // Worksite report
  InvoiceReport: FaFileInvoice,        // Invoice report
  EmployeeFutureSchedule: FaHelmetSafety, // Employee future schedule
  EmployeeUtilization: FaUsers,  // Employee utilization
  EquipmentUtilization: FaToolbox,      // Equipment utilization

  // Submenu icons under Settings
  RoleSettings: MdEditDocument,     // Roles
  DesignationSettings: IoDesktop,   // Designations
  ClassificationSettings: IoDesktop,   // Classification

  LeaveSettings: IoCalendarClear,   // Leave types
  CategoryLevelSettings: SiLevelsdotfyi, // Category level
  HolidaySettings: FaCalendarAlt,      // Holiday settings
  RolesPermissions: FaUserLock,     // Roles & Permissions
  EmailNotification: MdMarkEmailRead,   // Email settings

  // Submenu icons under Leave
  AllLeaves: BsPersonVideo2,        // All leaves
  LeaveCalender: IoCalendarSharp,        // Leave calendar
  Compensation: BsCalendar3WeekFill, // Compensation leave
  // Submenu icons under Schedule
  ScheduleReports: AiFillSchedule,        // Schedule report
  FSEKPI: RiFileList2Fill,                // FSE KPI
  FinanceReview: MdRateReview,         // Finance review
  ScheduleInvoice: FaFileInvoice,         // Invoice

};